import type { ReactNode } from 'react';
import { H5Regular, isNonMobileWeb, ScrollView, View, YStack } from 'smoothie';

import { BackgroundGradient } from '../../../common/components/BackgroundGradient';
import { NewMemberDisclosuresFooter } from './NewMemberDisclosuresFooter';
import { NewMemberHeader } from './NewMemberHeader';

const CONTENT_MAX_WIDTH = 480;

export const NewMemberScreenLayout = ({
    title,
    children,
}: {
    title: string;
    children: ReactNode;
}) => {
    return (
        <View height="100%" width="100%">
            <BackgroundGradient />
            <ScrollView
                height="100%"
                width="100%"
                showsVerticalScrollIndicator={isNonMobileWeb}
                contentContainerStyle={{ flexGrow: 1 }}
                keyboardShouldPersistTaps="handled"
            >
                <NewMemberHeader />

                <YStack
                    animation="slow"
                    enterStyle={{
                        opacity: 0,
                        scale: 0.98,
                        translateY: isNonMobileWeb ? 4 : 16,
                    }}
                    animateOnly={[
                        'opacity',
                        'transform',
                        'scale',
                        'translateY',
                    ]}
                    flex={1}
                    width="100%"
                    maxWidth={CONTENT_MAX_WIDTH}
                    alignSelf="center"
                    paddingTop={24}
                    paddingHorizontal={24}
                    gap={24}
                    $sm={{ paddingHorizontal: 32 }}
                >
                    <YStack alignItems="center" gap={4}>
                        <H5Regular textAlign="center">{title}</H5Regular>
                    </YStack>

                    {children}

                    <NewMemberDisclosuresFooter />
                </YStack>
            </ScrollView>
        </View>
    );
};
